<template>
    <svg xmlns="http://www.w3.org/2000/svg" v-bind:class="animation ? 'scroll-animation' : ''" width="20.201" height="49.076" viewBox="0 0 20.201 49.076">
        <path d="M9.101 11.132L.415 2.422a1.417 1.417 0 0 1 2-2.006l7.686 7.707L17.786.416a1.417 1.417 0 0 1 2 2.006l-8.685 8.71a1.412 1.412 0 0 1-2 0z" fill="#fff" opacity=".1"/>
        <path d="M9.101 29.896l-8.686-8.71a1.417 1.417 0 0 1 2-2.006l7.686 7.707 7.685-7.707a1.417 1.417 0 0 1 2 2.006l-8.685 8.71a1.412 1.412 0 0 1-2 0z" fill="#fff" opacity=".5"/>
        <path d="M9.101 48.66L.415 39.95a1.417 1.417 0 0 1 2-2.006l7.686 7.707 7.685-7.707a1.417 1.417 0 0 1 2 2.006l-8.685 8.71a1.412 1.412 0 0 1-2 0z" fill="#fff"/>
    </svg>
</template>

<style lang="scss" scoped>
    .scroll-animation {
        path {
            animation: animeScroll 1s linear infinite;

            &:nth-child(1) {
                animation-delay: .1s;
            }

            &:nth-child(2) {
                animation-delay: .3s;
            }

            &:nth-child(3) {
                animation-delay: .6s;
            }
        }
    }

    @keyframes animeScroll {
        from {
            opacity: 0;
        }

        50% {
            opacity: 1;
        }

        to {
            opacity: 0;
        }
    }
</style>

<script>
    export default {
        props: {
            animation: {
                type: Boolean,
                default: true
            }
        }
    }
</script>
